import { Link } from "react-router-dom";
import rouse_logo from "../assets/images/rouse_logo_3d.webp";
import {
  faFacebook,
  faInstagram,
  faReddit,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";



function Footer() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    window.onresize = () => {
      setWindowWidth(window.innerWidth);
    };
  }, []);
  return (
    <footer className="footer">
      <div className="container flex flex-row " style={{ gap: "60px" }}>
        <div className="col logo-col">
          <a href="#" className="footer-logo">
            <img className="logo" alt="Rouse logo" src={rouse_logo} />
          </a>
        </div>
        <div className="divider" />
        <nav className="col nav-col getinvolved">
          <p className="footer-heading">Get Involved</p>
          <ul className="footer-nav">
            <li className="footer-link">
              <Link to="/fund"  
                    onClick={() => {
                      window.scroll({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                      });
                    }} 
                    className="link">
                      Become an Investor
              </Link>
            </li>

            <li className="footer-link">
              <Link to="/join"   
                    onClick={() => {
                      window.scroll({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                      });
                    }} 
                    className="link">
                      Join the Community
              </Link>
            </li>
            <li className="footer-link">
              <Link to="/feedback"  
                    onClick={() => {
                      window.scroll({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                      });
                    }} 
                    className="link">
                      Give a Feedback
              </Link>
            </li>
            <li className="footer-link">
              <Link to="/about"  
                    onClick={() => {
                      window.scroll({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                      });
                    }} 
                    className="link">
                      About Us
              </Link>
            </li>
          </ul>
        </nav>
        <div className="divider" />
        <nav className="col nav-col resources">
          <p className="footer-heading">Resources</p>
          <ul className="footer-nav">
            <li className="footer-link">
              <Link to="/faq"  
                    onClick={() => {
                      window.scroll({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                      });
                    }} 
                    className="link">
                      FAQ
              </Link>
            </li>
            <li className="footer-link">
              <Link to="/ingredients"  
                    onClick={() => {
                      window.scroll({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                      });
                    }} 
                    className="link">
                      Ingredients
              </Link>
            </li>
            <li className="footer-link">
              <Link to="/source"  
                    onClick={() => {
                      window.scroll({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                      });
                    }} 
                    className="link">
                      Science & Sources
              </Link>
            </li>
            <li className="footer-link">
                <Link to="/terms"  
                      onClick={() => {
                        window.scroll({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                        });
                      }} 
                      className="link">
                        Privacy & Terms
                </Link>
            </li>
          </ul>
        </nav>
        <div className="divider" />
        <div className="col contact-col" style={{ height: "140px" }}>
          <p className="footer-heading">Contact</p>
          <ul className="social-links">
            <li>
              <a
                href="https://www.instagram.com/rouse_drink"
                className="footer-link"
                target="_BLANK"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  className="social-icon md hydrated"
                  icon={faInstagram}
                />
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/rousedrink"
                className="footer-link"
                target="_BLANK"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  className="social-icon md hydrated"
                  icon={faFacebook}
                />
              </a>
            </li>
            <li>
              <a
                href="https://www.tiktok.com/@rousedrink"
                className="footer-link"
                target="_BLANK"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  className="social-icon md hydrated"
                  icon={faTiktok}
                />
              </a>
            </li>
            <li>
              <a
                href="https://www.reddit.com/r/rousedrink/"
                className="footer-link"
                target="_BLANK"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  className="social-icon md hydrated"
                  icon={faReddit}
                />
              </a>
            </li>
          </ul>
          <address className="contacts">
            <p>
              <a className="contact-links" href="mailto:info@rousedrink.com">
                info@rousedrink.com
              </a>
            </p>
          </address>
        </div>
      </div>
      <div
        className="copyright"
        style={{ width: "100%", display: "flex", gap: '30px', flexDirection: windowWidth < 900 ? 'column' : 'row', marginBottom: '50px', alignItems: 'center', justifyContent: 'center' }}
      >
        <div>Designed by Balint T. Kertesz</div>
        <div>Copyright &copy; 2024, The Rouse Co.</div>
        <div>Developed by John Ward</div>
      </div>
    </footer>
  );
}

export default Footer;
